<template>
	<div class="vision-glasses-button-holder">
		<button
			@click="visionGlassesButtonHandler"
			type="button"
			class="vision-glasses-button"
			:class="{ 'is-active': ariaExpanded }"
			:title="message"
			:aria_expanded="isActiveVisionGlasses"
			tabindex="0"
		>
			<span class="visually-hidden">{{ message }}</span>
			<svg class="vision-glasses-button__icon" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg"><path d="M574.1 280.37L528.75 98.66c-5.91-23.7-21.59-44.05-43-55.81-21.44-11.73-46.97-14.11-70.19-6.33l-15.25 5.08c-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.79 8.38 11.85 12.91 20.23 10.12l13.18-4.39c10.87-3.62 23-3.57 33.16 1.73 10.29 5.37 17.57 14.56 20.37 25.82l38.46 153.82c-22.19-6.81-49.79-12.46-81.2-12.46-34.77 0-73.98 7.02-114.85 26.74h-73.18c-40.87-19.74-80.08-26.75-114.86-26.75-31.42 0-59.02 5.65-81.21 12.46l38.46-153.83c2.79-11.25 10.09-20.45 20.38-25.81 10.16-5.3 22.28-5.35 33.15-1.73l13.17 4.39c8.38 2.79 17.44-1.74 20.23-10.12l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24l-15.25-5.08c-23.22-7.78-48.75-5.41-70.19 6.33-21.41 11.77-37.09 32.11-43 55.8L1.9 280.37A64.218 64.218 0 0 0 0 295.86v70.25C0 429.01 51.58 480 115.2 480h37.12c60.28 0 110.37-45.94 114.88-105.37l2.93-38.63h35.75l2.93 38.63C313.31 434.06 363.4 480 423.68 480h37.12c63.62 0 115.2-50.99 115.2-113.88v-70.25c0-5.23-.64-10.43-1.9-15.5zm-370.72 89.42c-1.97 25.91-24.4 46.21-51.06 46.21H115.2C86.97 416 64 393.62 64 366.11v-37.54c18.12-6.49 43.42-12.92 72.58-12.92 23.86 0 47.26 4.33 69.93 12.92l-3.13 41.22zM512 366.12c0 27.51-22.97 49.88-51.2 49.88h-37.12c-26.67 0-49.1-20.3-51.06-46.21l-3.13-41.22c22.67-8.59 46.08-12.92 69.95-12.92 29.12 0 54.43 6.44 72.55 12.93v37.54z"/></svg>
		</button>
	</div>
</template>

<script>
	export default {
	name: 'VisionGlassesButton',

	props: {
		search_url: String,
	},

	data() {
		return {
			message: 'Версия для слабовидящих',
			isActiveVisionGlasses: false,
			pageElement: {}
		};
	},


	mounted() {
		this.pageElement = document.querySelector('.page');

		if (localStorage.isActiveVisionGlasses) {
			this.isActiveVisionGlasses = JSON.parse(localStorage.isActiveVisionGlasses);

			if (this.isActiveVisionGlasses) {
				this.pageElement.classList.add('vision-glasses-mode');
				this.message = 'Обычная версия';
			} else {
				this.pageElement.classList.remove('vision-glasses-mode');
				this.message = 'Версия для слабовидящих';
			}
		}
	},

	methods: {
		visionGlassesButtonHandler() {
			if (this.isActiveVisionGlasses) {
				this.pageElement.classList.remove('vision-glasses-mode');
				this.message = 'Версия для слабовидящих';
				this.isActiveVisionGlasses = false;
			} else {
				this.pageElement.classList.add('vision-glasses-mode');
				this.message = 'Обычная версия';
				this.isActiveVisionGlasses = true;
			}

			localStorage.isActiveVisionGlasses = JSON.stringify(this.isActiveVisionGlasses);
		}
	},
};
</script>

<style>
	.vision-glasses-button-holder {

	}

	.vision-glasses-button {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 50px;
		height: 50px;
		padding: 5px;
		border: none;
		border-radius: 10px;
		background-color: transparent;
	}

	.vision-glasses-button__icon {
		display: block;
		width: 26px;
		height: 26px;
		fill: var(--main-color);
	}

	@media (min-width: 1200px) {
		.vision-glasses-button-holder {
			position: relative;
			top: 0;
			right: 0;
			padding-left: 5px;

			&::before {
				content: "";
				position: absolute;
				top: 5px;
				left: 0;
				bottom: 5px;
				width: 1px;
				background-color: hsl(0, 0%, 85%);
			}
		}
	}
</style>
